import { ComponentDepend } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/ComponentDepend';
import { EnumRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';

export class ComponentDependExtend {
  public static Init(dto: ComponentDepend) {
    dto.relationshipType = EnumRelationshipType.ComponentDepend;
  }
}
